<template>
	<nav class="border-b">
		<div class="container mx-auto px-6 py-4 xl:px-14">
			<div class="flex flex-wrap items-center sm:justify-center">
				<div>
					<img src="@/assets/images/logo.png" class="h-12 w-auto">
				</div>
			</div>
		</div>
	</nav>
</template>
<script>

export default {
	components: {},
    data() {
        return {}
    },
    computed: {

    },
    methods: {}
}
</script>